import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import CssBaseline from "@mui/material/CssBaseline";
import MainLayout from "../../components/layout/MainLayout";
import ProductDetails from "../../components/product-details/ProductDetails";
import SEO from "../../components/seo";
import useConfigData from "../../hooks/useConfigData";

const Index = () => {
  const { configData, landingPageData, loading } = useConfigData();
  const { cartList, campaignItem } = useSelector((state) => state.cart);
  const [productDetails, setProductDetails] = useState([]);

  const handleProductDetails = useCallback(() => {
    // Since productDetailsData is not defined, this page is for campaign items only
    setProductDetails([{ ...campaignItem, isCampaignItem: true }]);
  }, [campaignItem]);

  useEffect(() => {
    handleProductDetails();
  }, [handleProductDetails]);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }

  return (
    <>
      <CssBaseline />
      <SEO
        title={
          configData
            ? `${productDetails[0]?.name || 'Product'}`
            : "Loading..."
        }
        image={`${configData?.base_urls?.item_image_url}/${productDetails[0]?.image}`}
        businessName={configData?.business_name}
        description={`${productDetails[0]?.description || ''}`}
      />
      <MainLayout configData={configData} landingPageData={landingPageData}>
        {productDetails.length > 0 && (
          <ProductDetails
            productDetailsData={productDetails[0]}
            configData={configData}
          />
        )}
      </MainLayout>
    </>
  );
};

export default Index;
